export enum GroundTypes {
    GRAS,
    PATH,
}